import React from "react";
import { useRecoilValue } from 'recoil'

import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";

import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { isLoggedInSelector } from '../login/loginAtoms'

import SidebarDesktopHeader from "./SidebarDesktopHeader";
import SidebarFocusAreaControls from "./SidebarFocusAreaControls.jsx"
import SidebarTabsContainer from "./SidebarTabsContainer";
import SidebarButtonBar from "./SidebarButtonBar"

const drawerBleeding = 40;
const drawerWidth = 600;

const StyledBox = styled(Box)(() => ({
	backgroundColor: "#1b2021",
}));

function SidebarDesktop({ open, setOpen }) {
	const isLoggedIn = useRecoilValue(isLoggedInSelector)	
	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen);
	};

	const width = `calc(${drawerWidth}px - ${drawerBleeding}px)`

	return (
		<>
			<Global styles={{
				".MuiDrawer-root > .MuiPaper-root": {
					width: width,
					overflow: "visible",
				},
			}} />
			<SwipeableDrawer
				variant="persistent"
				anchor="right"
				open={open}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
				disableSwipeToOpen={true}
				hideBackdrop
				ModalProps={{ keepMounted: true }}>
				<StyledBox sx={{
					display: "flex",
					flexDirection: "column",
					gap: 2,
					height: "100vh",
					maxHeight: "100vh",
					ml: 3,
					pr: 3,
					pb: 2,
					"& > *": {
						flexShrink: 0,
					}
				}}>
					{isLoggedIn && <Box sx={{
		        background: '#3787D2',
		        width: width,
		        ml: -3,
		        mb: -2,
		        pt: "0.3em",
		        pb: "0.2em",
		        pr: 3,
		        height: "36px",
		       	textAlign: "right",
		        "& a": {
		          color: "white",
		        }
		      }}>
		        <a
		          href="https://forms.office.com/Pages/ResponsePage.aspx?id=6j1lMAH7TEuN38GD-J_r-5yZsH-mj5lEshcKv-WTVPhUNlRNQ1FSUjNQTlRQRjExVllSWFowUTJMNiQlQCN0PWcu"
		          target="_blank"
		          rel="noopener">
		          Please provide feedback here
		        </a>
		      </Box>}
					<StyledBox sx={{
						position: "absolute",
						left: -drawerBleeding,
						visibility: "visible",
						right: drawerWidth - drawerBleeding - 1,
						top: 0,
						pointerEvents: "auto",
					}}>
						<IconButton disableRipple onClick={toggleDrawer(!open)}>
							{open ? <ArrowForwardIosIcon /> : <ArrowBackIosNewIcon />}
						</IconButton>
					</StyledBox>

					<SidebarDesktopHeader />
					<SidebarFocusAreaControls isMobile={false} />
					<SidebarTabsContainer isMobile={false} sx={{ flexGrow: 1 }} />
					<SidebarButtonBar />
				</StyledBox>
			</SwipeableDrawer>
		</>
	);
}

export default SidebarDesktop;
